import Cookies from 'js-cookie';

const getStorage = () => {
    try {
        // if sessionStorage is not supported use localStorage instead
        return typeof Storage !== "undefined" ? sessionStorage : localStorage;
    } catch {
        return null;
    }
}

export async function getMapiDataRequestURL(dataUrl, singleCinema, singleMovie, useSiteAsFilter, selectedFilters, testCinemasEnalbled, concessionEnabled ) {
    let requestURL = dataUrl + '?single_cinema=' + singleCinema;

    Object.keys(selectedFilters).forEach(filter => {
      requestURL += '&' + filter + '=' + selectedFilters[filter].join(',');
    });

    // handle experience page - add flag
    requestURL += '&isExperiencePage=' + useSiteAsFilter;

    // add is single movie flag
    requestURL += '&single_movie=' + singleMovie;

    // add test cinemas option
    requestURL += '&testCinemasEnalbled=' + (testCinemasEnalbled ? '1' : '0');

    // add test cinemas option
    requestURL += '&concessionEnabled=' + (concessionEnabled ? '1' : '0');

    // add the cookies to the filters - fix unique key issue
    const cinemaCity = Cookies.get('cinemaCity') || '';
    const cinemaCitySites = Cookies.get('cinemaCitySites') || '';
    const selectedMyCinema = Cookies.get('selectedMyCinema') || '';
    
    // Combine cookie values into a single string
    const combinedCookies = `${cinemaCity}|${cinemaCitySites}|${selectedMyCinema}`;

    // Generate hash for the unique key
    const uniqueCookiesValHash = await hashString(combinedCookies);

    return {
        full: requestURL,
        filters: requestURL.replace(dataUrl + '?', '') + ('&cookies=' + uniqueCookiesValHash),
    };
}

export async function getMapiData(requestURL) {
    const response = await fetch(requestURL);

    if (!response.ok) {
        return false;
    }

    const data = await response.json();
    return data || false;
}

export function getMapiCache(key) {
    const storage = getStorage();

    if (!storage) {
        return false;
    }

    const mapiData = storage.getItem('mapi-data');

    if (!mapiData) {
        return false;
    }
    
    const filterCache = JSON.parse(mapiData)[key];

    if (!filterCache) {
        return false;
    }
    
    const currentTime = new Date().getTime();
    
    if (currentTime > filterCache.expiryAt) {
        return false;
    }

    return filterCache.data;
}

export function setMapiCache(key, data, expiration = 2) {
    const storage = getStorage();

    if (!storage) {
        return false;
    }
    

    let storageData = storage.getItem('mapi-data');
    let mapiData;
    
    
    if (storageData) {
        mapiData = JSON.parse(storageData);
    } else {
        mapiData = {};
    }
    

    // save each filter data in a separate entry
    const now = new Date().getTime();
    const expiry = now + 1000 * 60 * expiration;
    const filterData = {
        expiryAt: expiry,
        data: data,
    };
    
    mapiData[key] = filterData;

    return storage.setItem('mapi-data', JSON.stringify(mapiData));
}

async function hashString(value) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}